import { ReactComponent as AMERICAN_EXPRESS } from './americanexpress.svg';
import { ReactComponent as DINERS_CLUB } from './dinnerclub.svg';
import { ReactComponent as DISCOVER } from './discover.svg';
import { ReactComponent as JCB } from './jcb.svg';
import { ReactComponent as MASTERCARD } from './mastercard.svg';
import { ReactComponent as VISA } from './visa.svg';

export const ICONS = { VISA, MASTERCARD, AMERICAN_EXPRESS, DISCOVER, DINERS_CLUB, JCB };
